import { h, Component } from 'preact';
import cn from 'classnames';
import styles from './icon.css';

// Import references to all files in the `./svg` directory, but only if we're not in test
const glyphs = {};
const req = require.context('./svg', true);
req.keys().forEach((key) => {
	glyphs[key.replace('./', '').replace('.svg', '')] = req(key);
});

const Icon = ({ glyph, size, className, onClick }) => (
  <svg onClick={onClick} className={cn(styles.icon, className)} width={size} height={size}>
    <use xlinkHref={glyphs[glyph].default} />
  </svg>);

Icon.defaultProps = {
  size: 24
};


export default Icon;



// WEBPACK FOOTER //
// ./components/icon/icon.jsx